module.exports = __webpack_public_path__ + "75a39980e1e34f71f009fd49050f075c.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/header/shaffi11-xsmall.jpg
// module id = ZihT
// module chunks = 0